export default __webpack_public_path__ + "7b55b779913da997d700da451d767193.svg";